import React from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyToGetStarted() {
  return <section data-section-id="260375" id="שאלות-נפוצות" className="bg-background text-foreground">
      <div className="bg-primary text-primary-foreground py-20 px-6 md:px-12 flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
          זקוקים למטפל סיעודי באופן מיידי?
        </h2>
        
        <p className="text-primary-foreground/80 max-w-2xl mx-auto mb-8 text-lg md:text-xl font-default">
          מענה אנושי 24/7, התאמה אישית של מטפל תוך 5 שעות וליווי מקצועי לאורך כל הדרך. אנחנו כאן בשבילכם.
        </p>
        
        <Button asChild size="lg" className="bg-chart-3 text-primary-foreground hover:bg-chart-3/90 rounded-lg text-lg h-14 px-8 mb-8 font-default font-bold shadow-lg">
          <Link to="tel:072-392-2469">
            <Phone className="ml-2 size-5" />
            חייגו עכשיו: 072-392-2469
          </Link>
        </Button>
        
        <p className="text-sm text-primary-foreground/60 font-default font-medium">
          זמינות ארצית • צוות מוסמך ומנוסה • פתרונות סיעוד מקיפים לכל גיל
        </p>
      </div>
    </section>;
}